import { createElement, memo, useCallback } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import TextInput from '@hfe/max-textinput';
import Icon from '@max/leez-icon';
import { searchCities } from '../cityUtil';
import './index.scss';
function SearchArea(props) {
    const { cities, currentCityName, onClose, onSearchChange, onSelectCity, searchKeyword } = props;
    const suggestList = searchKeyword ? searchCities(cities, searchKeyword) : [];
    const handleChange = useCallback((value) => {
        onSearchChange(value);
    }, [onSearchChange]);
    return <View className="cfe-search-area">
      <View className="cfe-search-row">
        <View className="cfe-search-input-wrap">
          <Icon name='search-line-regular' type='title1' className='demo-icon-icon' iconFontType='meishi' color='#999999'/>
          <TextInput className="cfe-search-input" placeholder="城市/区县" placeholderColor="#999999" value={searchKeyword} onChangeText={handleChange}/>
        </View>
        <View className="cfe-search-close-wrap" onClick={onClose}>
          <Text className="cfe-search-close">✕</Text>
        </View>
      </View>

      {searchKeyword !== '' && suggestList.length > 0 && <View className="cfe-suggest-list">
          {suggestList.map(city => <View key={String(city.id)} className="cfe-suggest-item" onClick={() => onSelectCity(city)}>
              <Text className="cfe-suggest-text">{city.name}</Text>
              <View className="cfe-suggest-divider"/>
            </View>)}
        </View>}

      {searchKeyword !== '' && suggestList.length === 0 && <View className="cfe-not-found">
          <Text className="cfe-not-found-text">未找到相关城市/区县</Text>
        </View>}

      {searchKeyword === '' && currentCityName && <View className="cfe-current-city-row">
          <Text className="cfe-current-city-text">{`当前城市: ${currentCityName}`}</Text>
          <View className="cfe-current-city-divider"/>
        </View>}
    </View>;
}
export default memo(SearchArea);
